import React, { useEffect, useState } from "react";
import { api, brl } from "../../lib/api";
import { toast } from "sonner";

export default function AdminLimitRequests() {
  const [items, setItems] = useState([]);

  const load = async () => setItems((await api.get("/limit-requests")).data);
  useEffect(() => { load(); }, []);

  const decide = async (id, approve, final_limit) => {
    try {
      await api.post(`/limit-requests/${id}/decide`, { approve, final_limit });
      toast.success(approve ? "Aprovado" : "Rejeitado");
      load();
    } catch (e) {
      toast.error("Erro ao decidir");
    }
  };

  return (
    <div data-testid="admin-limits-page">
      <div className="topbar">
        <h1 className="font-display text-4xl font-bold tracking-tight">Solicitacoes de Limite</h1>
      </div>
      <div className="table-wrap">
        <table className="crl">
          <thead><tr><th>Cliente</th><th>Limite atual</th><th>Solicitado</th><th>Motivo</th><th>Status</th><th>Acoes</th></tr></thead>
          <tbody>
            {items.map((r) => (
              <tr key={r.id}>
                <td>{r.client_id.slice(0, 8)}...</td>
                <td className="tabular">{brl(r.current_limit)}</td>
                <td className="tabular font-medium">{brl(r.requested_limit)}</td>
                <td className="text-[#5C5A57] text-xs">{r.reason || "-"}</td>
                <td><span className={`badge ${r.status === "approved" ? "green" : r.status === "rejected" ? "red" : "medio"}`}>{r.status}</span></td>
                <td>
                  {r.status === "pending" && (
                    <div className="flex gap-2">
                      <button className="brand" style={{ padding: "6px 12px", fontSize: 10 }} onClick={() => decide(r.id, true, r.requested_limit)} data-testid={`approve-${r.id}`}>Aprovar</button>
                      <button onClick={() => decide(r.id, false, r.requested_limit)} className="text-xs uppercase tracking-widest text-[#8B5E5E] hover:underline" data-testid={`reject-${r.id}`}>Rejeitar</button>
                    </div>
                  )}
                </td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan="6" className="text-center text-sm text-[#5C5A57] py-8">Sem solicitacoes pendentes.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
